import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  fetchHubspotSyncListing,
  submitHubspotSyncListingData,
} from "../../redux/actions/settingActions";
import * as Icon from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";

const SettingSyncedHubspot = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [hubspotData, setHubspotData] = useState([]);
  const hubspot_permissions = useSelector((state) => state.setting.hubspotSyncData);
  const title_data = [
    {
      heading:" Zoi --> HubSpot",
      title: "Sync leads from Zoi to Hubspot",
      sub_title: "New leads from Zoi will be created in HubSpot",
      child_exist: true,
      type: [
        {
          title: "Real-time Sync",
          sub_title: "Get immediate sync for new leads."
        },
        {
          title: "Daily Sync",
          sub_title: "Get daily sync for new leads."
        },
      ]
    },
    {
      heading:" HubSpot --> Zoi",
      title: "Sync leads from Hubspot to Zoi.",
      sub_title: "New leads from HubSpot will be created in Zoi.",
      child_exist: false,
      type: [
        {
          title: "Real-time Sync",
          sub_title: "Get immediate sync for new leads."
        },
        {
          title: "Daily Sync",
          sub_title: "Get daily sync for new leads."
        },
      ]
    }
  ];
  
  useEffect(() => {
    dispatch(fetchHubspotSyncListing(props.authToken));
  }, [])
  
  
  useEffect(() => {
    if (hubspot_permissions?.length > 0) {
      let hub_array = [...hubspot_permissions];
      if (hub_array?.length > 0) {
        hub_array.map((item, ind) => {
          item.heading = title_data[ind]?.heading;
          item.title = title_data[ind]?.title;
          item.sub_title = title_data[ind]?.sub_title;
          item.child_exist = title_data[ind]?.child_exist;
          if (item.type.length > 0) {
            item.type.map((inner, index) => {
              inner.title = title_data[ind]?.type[index]?.title;
              inner.sub_title = title_data[ind]?.type[index]?.sub_title;
              return inner;
            })
          }
          return item;
        })
      }
      setHubspotData(hub_array);
      console.log("hubspotData", hubspotData);
    }
  }, [hubspot_permissions]);

  // const addState = (data) => {
  //     setHubspotData(data);
  // };
  
  const handleDataCheck = (check, parent) => {
    let hub_array = [...hubspot_permissions];
    hub_array.map((item, ind) => {
      if (ind === parent) {
        item.permission_check = check;
      }
      return item;
    })
    setHubspotData(hub_array);
    console.log("hubspotData", hub_array);
  }
  
  const handleInnerDataCheck = (check, parent, child) => {
    let hub_array = [...hubspot_permissions];
    hub_array.map((item, ind) => {
      if (ind === parent) {
        item.type.map((inner, index) => {
          if (index === child) {
            inner.check = true;
          } else {
            inner.check = false;
          }
          return inner;
        })
      }
      return item;
    })
    setHubspotData(hub_array);
    console.log("hubspotData", hub_array);
  }
  
  const submitHandler = () => {
    dispatch(submitHubspotSyncListingData(props.authToken, hubspotData, onSuccess))
  }
  
  const onSuccess = () => {
    navigate("/Setting/hubspot");
  }

  return (
    <>
      <div className="py-2">
        <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
          <div className="text-lg leading-7 font-[500] my-auto">
            Synced HubSpot Data
          </div>
          <div className="flex items-center">
            <button
              onClick={()=>{navigate("/Setting/hubspot")}}
              type="button"
              className="mr-4 inline-flex border border-gray-300 items-center gap-x-1.5 rounded-md bg-transparent hover:bg-[#bcc2c3] px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm"
            >
              <Icon.ChevronLeft className="text-[#000000]"/> <span>Back</span>
            </button>
            <button
              onClick={submitHandler}
              type="button"
              className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
            >
              Save Changes
            </button>
          </div>
        </div>
        <div className="overflow-auto h-[75vh] mt-4 bg-white rounded-t-md border border-solid border-[lightgray] px-4 py-3 syncField">
          <div className="max-sm:mt-4 flow-root">
            <div>
                <fieldset>
                  <legend className="sr-only">Sync</legend>
                  <div className="space-y-5">
                  {hubspotData && hubspotData?.map((data, d_index) => {
                    return (
                      <div key={"key-"+d_index} className="border-b border-gray-200 pb-4">
                      <p className="text-lg font-semibold text-gray-600 mb-4">{data.heading}</p>
                      <div className="relative flex mb-4 items-start">
                        <div className="flex h-6 items-center">
                          <input
                            id="realtime"
                            aria-describedby="realtime-description"
                            name="realtime"
                            type="checkbox"
                            checked={data.permission_check}
                            onChange={(e) => {
                              handleDataCheck(e?.target?.checked , d_index)
                            }}
                            className="h-4 w-4 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                          />
                        </div>
                        <div className="ml-3 text-sm leading-6">
                          <label htmlFor="realtime" className="font-medium text-gray-900">
                            {data.title}
                          </label>
                          <p id="realtime-description" className="text-gray-500">
                            {data.sub_title}
                          </p>
                        </div>
                      </div>
                        {(data?.permission_check === true && data?.child_exist === true) &&
                          <>
                            {data?.type.map((inner_data,i_index) => {
                              return (
                                <div key={"key-1-"+i_index} className="space-y-5">
                                  <div className="relative flex items-start">
                                    {/* <span className="text-gray-400">{"--->"}</span> */}
                                    <div className="flex h-6 items-center ml-10">
                                      <input
                                        id={"radio-1"}
                                        name="sync-method"
                                        type="radio"
                                        checked={inner_data.check}
                                        onChange={(e) => {
                                          handleInnerDataCheck(e?.target?.checked , d_index, i_index )
                                        }}
                                        className="h-4 w-4 border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                                      />
                                    </div>
                                    <div className="ml-3 text-sm leading-6">
                                      <label htmlFor="realtime" className="font-medium text-gray-900">
                                        {inner_data.title}
                                      </label>
                                      <p id="realtime-description" className="text-gray-500">
                                        {inner_data.sub_title}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        }
                    </div>
                    );
                  })}
                  </div>
                </fieldset>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingSyncedHubspot;
